package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import net.frozenbit.games.soundgame.theme.Typography

@Composable
fun ControllerGameOverScreen(
    actionTexts: List<String>,
    onActionClick: (index: Int) -> Unit,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(16.dp, Alignment.Top),
        modifier = Modifier
            .fillMaxSize()
            .padding(8.dp)
    ) {
        Text(
            "Spiel zu Ende. Nochmal spielen?",
            fontSize = Typography.Controller.title,
        )
        actionTexts.forEachIndexed { index, actionText ->
            Button(
                modifier = Modifier
                    .fillMaxWidth(),
                onClick = { onActionClick(index) },
            ) {
                Text(
                    actionText,
                    fontSize = Typography.Controller.body,
                )
            }
        }
    }
}